import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class app_custom_ds_get_lots_for_order_importService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { lotLookupcodes?: string[], materialLookupcodes?: string[], projectLookupcodes?: string[], vendorLotLookupcodes?: string[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Material?: { Id?: number, LookupCode?: string, Project?: { Id?: number, LookupCode?: string } }, Lots?: { Id?: number, LookupCode?: string }[] }[] }> 
  {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { lotLookupcodes?: string[], materialLookupcodes?: string[], projectLookupcodes?: string[], vendorLotLookupcodes?: string[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Material?: { Id?: number, LookupCode?: string, Project?: { Id?: number, LookupCode?: string } }, Lots?: { Id?: number, LookupCode?: string }[] }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { lotLookupcodes?: string[], materialLookupcodes?: string[], projectLookupcodes?: string[], vendorLotLookupcodes?: string[], $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Material?: { Id?: number, LookupCode?: string, Project?: { Id?: number, LookupCode?: string } }, Lots?: { Id?: number, LookupCode?: string }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      lotLookupcodes?: string[], materialLookupcodes?: string[], projectLookupcodes?: string[], vendorLotLookupcodes?: string[]    }) {
      return false;
    }
}
